// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3tNj4","footer":"ModalCreateQualiphyProcedure_footer__bPGP6","additionData":"ModalCreateQualiphyProcedure_additionData__Wgey2"};